import { render, staticRenderFns } from "./AdminTournamentSettings.vue?vue&type=template&id=3b7344f1"
import script from "./AdminTournamentSettings.vue?vue&type=script&lang=js"
export * from "./AdminTournamentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports